/**
 * Shared constants and helpers used across CRM Web frontend
 */

// Gradientes de color fijo por agente (para avatars en ChatWindow)
export const AGENT_COLORS = [
  'linear-gradient(135deg, #3B82F6, #1D4ED8)',  // Blue
  'linear-gradient(135deg, #10B981, #047857)',  // Emerald
  'linear-gradient(135deg, #8B5CF6, #6D28D9)',  // Violet
  'linear-gradient(135deg, #F59E0B, #D97706)',  // Amber
  'linear-gradient(135deg, #EF4444, #DC2626)',  // Red
  'linear-gradient(135deg, #EC4899, #DB2777)',  // Pink
  'linear-gradient(135deg, #06B6D4, #0891B2)',  // Cyan
  'linear-gradient(135deg, #F97316, #EA580C)',  // Orange
]

/**
 * Genera datos de avatar para un agente (inicial + gradiente)
 * Usado en ChatWindow para mostrar el avatar del agente asignado
 */
export function getAgentAvatar(agentName) {
  if (!agentName || agentName === 'Ninguno') {
    return { initial: null, gradient: '#D1D5DB' }
  }
  let hash = 0
  for (let i = 0; i < agentName.length; i++) {
    hash = ((hash << 5) - hash) + agentName.charCodeAt(i)
    hash |= 0
  }
  return {
    initial: agentName.charAt(0).toUpperCase(),
    gradient: AGENT_COLORS[Math.abs(hash) % AGENT_COLORS.length]
  }
}
